import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './auth/auth.service';
import { tap } from 'rxjs/operators';
import * as moment from 'moment';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable()
export class InterseptorsService implements HttpInterceptor {
  private redirectInProgress = false;
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const currentTime: any = moment().format("YYYY-MM-DD[T]HH:mm:ss.SSS");
    // set default header in all request
    let modified = req.clone({
      setHeaders: {
        "Content-Type": "application/json",
        currentTime: currentTime,
      },
      withCredentials: true,
    });
    // send bearer token and user id only if user is logged in
    if (this.authService.isLoggedIn()) {
      const id_token: any = this.authService.returnToken(); // return token
      const user_id: any = this.authService.returnUserId(); // return user_id
      const userTimeZone: any = new Date().getTimezoneOffset(); // set time zone in header
      const userTimeZoneString = `UTC${userTimeZone > 0 ? '+' : ''}${userTimeZone}`;
      const pagePath: any = window.location.pathname; /* Path of the Route */
      // set user id , timezone and token in header for all request after user logged in
      // tslint:disable-next-line:max-line-length
      modified = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + id_token,
          user_id: user_id,
          userTimeZone: `${userTimeZone}`,
          currentTime: currentTime,
          pagePath: pagePath
        },
        withCredentials: true
      });
    }
    return next.handle(modified).pipe(
      tap(
        event => {},
        error => {
          // Several startup requests can receive a transfer response together.
          // Once navigation starts, later responses must not redirect or log out.
          if (this.redirectInProgress) return;
          if (error instanceof HttpErrorResponse) {
            // logout after status 401
            if (error.status === 401) {
              this.authService.logout().subscribe(data => {});
            }
            if (error.status === 403) {
              if(error.error.status === 6) {
                this.authService.showMfaPopup();
              } else {
                this.authService.showReloginPopup();
              }
            }
            if (error.status === 409 && error.error.redirect) {
              this.redirectInProgress = true;
              window.location.href = error.error.redirect;
            }
          }
        }
      )
    );
  }
  constructor(private authService: AuthService) {}
}
